import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import 'slick-carousel'; 
import './libs/slicks';

$(document).ready(() => {
  console.log('Hello word!');
});


$('.ham').on('click', () => {
  $('.ham, .header__mobile-menu').toggleClass('active');
});
// Your scripts here


$(".oferta_menu").click(function (){
  $('html, body').animate({
    scrollTop: $('.pl').offset().top - 100
  }, 500, 'linear');
});
$(".galeria_menu").click(function (){
  $('html, body').animate({
    scrollTop: $('.gallery').offset().top - 50
  }, 500, 'linear');
});
$(".fakty_menu").click(function (){
  $('html, body').animate({
    scrollTop: $('.count').offset().top - 100
  }, 500, 'linear');
});
$(".kontakt_menu").click(function (){
  $('html, body').animate({
    scrollTop: $('.contact').offset().top - 100
  }, 500, 'linear');
});
$(".gdzie_menu").click(function (){
  $('html, body').animate({
    scrollTop: $('.where_shot').offset().top - 100
  }, 500, 'linear');
});